import React from "react";

import { capitalizeAndJoin } from "@cayuse/shared-react.utils.helpers";
import { api } from "services";

import { PersonSearchOption } from "components/flowable/FlowablePersonSearch/components/PersonSearchOption/PersonSearchOption";


export const getCellWidth = (name, isSmallDesktopView, isTabletView) => {
	switch (name) {
	case "internalAssociation":
		if (isSmallDesktopView) {
			return "41%";
		} else if (isTabletView) {
			return "80%";
		} else {
			return "36%";
		}

	case "creditField":
		if (isSmallDesktopView) {
			return "14%";
		} else if (isTabletView) {
			return "20%";
		} else {
			return "7%";
		}

	case "sponsoredEffort":
		if (isSmallDesktopView) {
			return "45%";
		} else if (isTabletView) {
			return "100%";
		} else {
			return "25%";
		}

	case "costShareEffort":
		if (isSmallDesktopView) {
			return "70%";
		} else if (isTabletView) {
			return "85%";
		} else {
			return "25%";
		}

	case "totalEffort":
		if (isSmallDesktopView) {
			return "30%";
		} else if (isTabletView) {
			return "15%";
		} else {
			return "7%";
		}

	default:
		break;
	}
};

export const getPreselectedAssociation = async personId => {
	const data = await api.person.get({ id: personId });
	const primaryAssociation = (data.affiliations ?? []).find(
		affiliation => affiliation.primaryAppointment
	);

	const user = {
		key: data.id,
		value: data.id,
		text: data.name,
		person: {
			personId: data.id,
			...data,
		},
		content: (
			<PersonSearchOption
				option={{
					name: data.name,
					email: data.contactEmail,
					title: primaryAssociation?.title,
					profileTypes: capitalizeAndJoin(data.profileTypes),
				}}
			></PersonSearchOption>
		),
	};

	return user;
};
